import { render } from "./ventes_view_tab.vue?vue&type=template&id=19112b22"
import script from "./ventes_view_tab.vue?vue&type=script&lang=js"
export * from "./ventes_view_tab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__